import appStore from 'store';
import api from './api';
import { STATUS_TYPE, DEPOSIT_STATUS_TYPE } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: '1',
    allCoins: [],
    chooseCoinType: '',
    userRecords: [],
    audistCount: 0,
    userDetailTotal: 0,
    userWallet: [],
    chainsData: [],
    pagination: { page: 1, size: 25 },
    idStr: '',
    /** 已勾选行（批量审核表格用）；与 idStr 同源更新 */
    selectedWithdrawRows: []
  },
  getters: {
    allcoins: state => state.allCoins.slice().map(item => {
      if (item.split('_')[1] == 'TRC20') {
        return 'USDTTRC'
      } else if (item.split('_')[1] == 'ERC20') {
        return 'USDT'
      } else {
        return item.split('_')[1]
      }
    })
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.slice().map(item => {
        return {
          ...item,
          __status: STATUS_TYPE[item.txStatus]
        };
      });
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    },
    setChooseTab(state, payload) {
      state.activeTab = payload;
    },
    setBillTypeList(state, payload) {
      state.billTypeList = payload;
    },
    setAllcoins(state, payload) {
      state.allCoins = payload;
    },
    setAudistCount(state, payload) {
      state.audistCount = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setUserRecords(state, payload) {
      state.userRecords = payload.slice().map(item => {
        return {
          ...item,
          __status:
            item.txType === 1
              ? DEPOSIT_STATUS_TYPE[item.txStatus]
              : STATUS_TYPE[item.txStatus]
        };
      });
    },
    setUserDetailTotal(state, payload) {
      state.userDetailTotal = payload;
    },
    setChooseCoinType(state, payload) {
      state.chooseCoinType = payload;
    },
    setUserWallet(state, payload) {
      state.userWallet = payload;
    },
    setChainData(state, payload) {
      state.chainsData = payload;
    },
    setIdStr(state, payload) {
      state.idStr = payload
    },
    setSelectedWithdrawRows(state, payload) {
      state.selectedWithdrawRows = payload ? payload.slice() : [];
    },
    resetWithdrawalBatchPick(state) {
      state.idStr = '';
      state.selectedWithdrawRows = [];
    }
  },
  actions: {
    getExcelData({ commit }, params) {
      return api.getExcelData(params).then(res => {
        return res
      })
    },
    exportExcel({ commit }, data) {
      return api.exportExcel(data).then(res => {
        return res
      })
    },
    getChains({ commit }) {
      api.getChains().then(res => {
        commit('setChainData', res.data)
      })
    },
    list({ commit }, query) {
      api.getAuditList(query).then(({ data }) => {
        commit('setAuditList', data.list || []);
        commit('setAudistCount', data.totalCount || 0);
        commit('setPagination', { page: query.page, size: query.size });
      });
    },
    // eslint-disable-next-line
    approve({ commit }, data) {
      return new Promise(resolve => {
        api.approveAudit(data).then(res => {
          resolve(res);
        });
      });
    },
    submitWithdrawReviewList(context, data) {
      return api.submitWithdrawReviewList(data);
    },
    // eslint-disable-next-line
    retry({ commit }, data) {
      return new Promise(resolve => {
        api.retryWithdrawal(data).then(res => {
          resolve(res);
        });
      });
    },
    setAuditToErr(context, id) {
      return new Promise(resolve => {
        api.setToErrList(id).then(res => {
          resolve(res);
        });
      });
    },
    cancelTheAudit(context, id) {
      return new Promise(resolve => {
        api.cancel(id).then(res => {
          resolve(res);
        });
      });
    },
    listBillType({ commit }) {
      api.getBillTypeList().then(({ data }) => {
        commit('setBillTypeList', data);
      });
    },
    getAllCoins({ commit }) {
      api.getAllCoins().then(({ data }) => {
        commit('setAllcoins', data);
      });
    },
    getUserRecords({ commit }, data) {
      api.getUserRecords(data).then(({ data }) => {
        commit('setUserRecords', data.list || []);
        commit('setUserDetailTotal', data.totalCount || 0);
      });
    },
    getUserWallet({ commit }, data) {
      api.getUserWallet(data.userId).then(({ data }) => {
        commit('setUserWallet', data);
      });
    },
    resetUserRecords({ commit }) {
      commit('setUserRecords', []);
      commit('setUserDetailTotal', 0);
      commit('setUserWallet', []);
    },
    changeCoinType({ commit }, data) {
      commit('setChooseCoinType', data);
    },
    changeChooseTab({ commit }, data) {
      commit('setChooseTab', data);
    },
    updateFreeze(context, data) {
      return api.updateFreeze(data);
    },
    cancel(context, data) {
      return api.cancel(data);
    },
    sendWithdrawalTrans(context, data) {
      return api.sendTheWithdrawalTrans(data);
    },
    remark(context, data) {
      return api.remark(data);
    },
    manualConfirm(context, txId) {
      return api.manualConfirm(txId);
    },
    returnToNotApproved(context, txId) {
      return api.returnToNotApproved(txId);
    },
    sentConfirmed(context, data) {
      return api.sentConfirmed(data);
    },
    checkWithdrawGoogleSession() {
      return api.getWithdrawGoogleAuthSession();
    },
    verifyWithdrawReviewGoogle(context, googleCode) {
      return api.verifyWithdrawGoogleAuth({ googleCode });
    },
    getWithdrawApprovalTimeline(context, id) {
      return api.getWithdrawApprovalTimeline({ id });
    },
    submitWithdrawReview(context, payload) {
      return api.submitWithdrawReview(payload);
    },
    fetchWithdrawReviewTxBounds(context, params) {
      return api.getWithdrawReviewTxBounds(params);
    },
    fetchWithdrawReviewTxSummary(context, params) {
      return api.getWithdrawReviewTxSummary(params);
    },
    fetchWithdrawReviewTxPage(context, params) {
      return api.getWithdrawReviewTxPage(params);
    }
  }
};

appStore.registerModule('withdrawalAudit', store);
